import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

export interface PersonalizedOfferRoutesParams {
  id: string;
}

const AsyncNewPoContainer = Load(
  () => import(/* webpackChunkName: "host-po" */ './NewPoContainer'),
  {},
  true,
);
const AsyncCreatePoContainer = Load(
  () => import(/* webpackChunkName: "host-po" */ './CreatePoContainer'),
  {},
  true,
);
const AsyncUpdatePoContainer = Load(
  () => import(/* webpackChunkName: "host-po" */ './UpdatePoContainer'),
  {},
  true,
);

const PersonalizedOfferRoutes = [
  <Route key="newoffer" path={`${basePath}/new-personalized-offer/:id`}>
    <AsyncNewPoContainer />
  </Route>,
  <Route key="createoffer" path={`${basePath}/create-personalized-offer/:id`}>
    <AsyncCreatePoContainer />
  </Route>,
  <Route key="updateoffer" path={`${basePath}/update-personalized-offer/:id`}>
    <AsyncUpdatePoContainer />
  </Route>,
];

export default PersonalizedOfferRoutes;
